module.exports = __webpack_public_path__ + "images/shop/favicon-carpardoo/android-chrome-192x192.png";